import classNames from "classnames";

import "./ResponsiveContainer.scss";

type CONTAINER_SIZES = "small" | "medium" | "large";

type ResponsiveContainerProps = {
  fullWidth?: boolean;
  size?: CONTAINER_SIZES;
};

/**
 * @deprecated component has been moved, use ResponsiveContainer from @jti/ui instead
 */

export const ResponsiveContainer = ({
  children,
  fullWidth = false,
  size,
}: React.PropsWithChildren<ResponsiveContainerProps>) => {
  const currentClassNames = classNames("responsive-container", {
    "responsive-container--full-width": fullWidth,
    [`responsive-container--${size}`]: size,
  });

  return <div className={currentClassNames}>{children}</div>;
};
